import type { MathRun } from '../../../Shared/Pdf/mathRuns.ts';

/** French number-property prompts (ADR 0051 part 3). */
export const numberPropertyPrompts = {
    multiples: (count: number, base: number) => `Écris les ${count} premiers multiples de ${base}.`,
    gcf: (a: number, b: number) => `Quel est le plus grand commun diviseur de ${a} et ${b} ?`,
    lcm: (a: number, b: number) => `Quel est le plus petit commun multiple de ${a} et ${b} ?`,
    primeComposite: (value: number) => `${value} est-il premier ou composé ?`,
    evenOdd: (value: number) => `${value} est-il pair ou impair ?`,
    // ADR 0132. The radical is a run, drawn by MathText; the French question mark
    // keeps its no-break space (U+00A0, which WinAnsi has).
    estimatingRoots: (radicand: number): MathRun[] => [
        { text: 'Entre quels deux nombres entiers se trouve ' },
        { root: String(radicand) },
        { text: ' ?' },
    ],
    factors: (value: number) => `Écris tous les diviseurs de ${value}.`,
};

export const primeCompositeLabels = { prime: 'Premier', composite: 'Composé' };
export const evenOddLabels = { even: 'Pair', odd: 'Impair' };

/** The key to an estimating question: the two whole numbers a root falls between. */
export const rootPairKey = (lower: number, upper: number) => `${lower} et ${upper}`;
